import React from 'react'
import {
  Icon,
  Message,
  Popup
} from 'semantic-ui-react'
// Local
import { EncounterReview } from '../../authenticated/types'
import If from '../../common/if'
import {
  hasReviewQueryOutstanding,
  isReadyForCdiQa,
  reviewerName
} from '../../common/reviewUtils'
import { shouldRenderReskin2025 } from '../../../constant'
import ReveleerCoachingBox from '../../ReveleerCoachingBox'

type Props = {
  review: EncounterReview | null | undefined
}

type InfoMessageProps = {
  isReadyForQa: boolean
  review: EncounterReview | null | undefined
}

function InfoMessage(
  props: InfoMessageProps
): JSX.Element {
  const {
    isReadyForQa,
    review
  } = props
  return (
    <>
      <div className="bold">CDI Patient Review</div>
      <If isTrue={ isReadyForQa }>
        <div>
          <span>Ready for CDI QA</span>
          <If isTrue={ !!reviewerName(review) }>
            <span>: { reviewerName(review) }</span>
          </If>
        </div>
      </If>
      <If isTrue={ hasReviewQueryOutstanding(review) }>
        <div className="m-1-top">
          <Popup
            content="CDI Follow-Up Requested"
            trigger={
              <Icon
                name="hourglass half"
                color="red"
              />
            }
          />
          <span>&nbsp;</span>
          <span>CDI follow-up requested</span>
        </div>
      </If>
    </>
  )
}

function RenderLeft(
  props: Props
): JSX.Element {
  const {
    review
  } = props
  const isReadyForQa = isReadyForCdiQa(review)
  return (
    <>
      <If isTrue={ !shouldRenderReskin2025 }>
        <Message
          warning={ !shouldRenderReskin2025 }
          className="cdi"
        >
          <InfoMessage
            isReadyForQa={ isReadyForQa }
            review={ review }
          />
        </Message>
      </If>
      <If isTrue={ shouldRenderReskin2025 }>
        <ReveleerCoachingBox
          coachingBoxType="infoPositive"
          isShowing
          message={
            <InfoMessage
              isReadyForQa={ isReadyForQa }
              review={ review }
            />
          }
        />
      </If>
    </>
  )
}

export default RenderLeft
